import React from "react";
import { useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import HelmetWrapper from "../../HelmetWrapper";
import { selectUser } from "../../components/auth/auth.selector";
import SalesCard from "../home/common/SalesCard";

const ActiveMembers = () => {
  const userInfoData = useSelector(selectUser);

  return (
    <HelmetWrapper title="WTF: Active Members">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Row>
          <Col>
            <SalesCard user={userInfoData} clickedCard={"active_members"} />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default ActiveMembers;
